module.exports = __webpack_public_path__ + "img/lowa-banner.2d3a5426.jpg";